import { SET_MENU } from './mutations_types';

export default {
  [SET_MENU](state, menu) {
    state.menu = menu;
  },
};
